 <template>
	<div v-show="parcela">

		<div class="iconBoxBack" @click="$emit('backOption')"
			:style="{ color: parceiroConfig.corPrimaria }">
			<i class="fas fa-chevron-left" ></i>
			Voltar
		</div>

			<h3
				class="titleOption">
				Confirmação de Pagamento
			</h3>

			<div class="infos-row" v-if="parcela">

				<div class="infos">
					<h6>Forma de pagamento</h6>
					<h2>{{ tipoPagamentoFormatado }}</h2>
				</div>

				<div class="infos">
					<h6>Parcelas</h6>
					<h2
						class="titleOption">
						{{tituloConfirmacaoDePagamento}}
					</h2>
				</div>

				<div class="infos">
					<h6>Valor total</h6>
					<h2>R$ {{ parcela.valor_total_acordo | formatarDinheiro }}</h2>
				</div>

			</div>

		<h3 class="titleOption">Confirmação do acordo</h3>

		<div class="infos">
			<h6 class="text-cofirm">
				{{ textoConfirmarAcordo }}
			</h6>

			<div
				class="checkTerm"
				@click="checkTerm = !checkTerm" >

				<i :class="checkTerm ? 'far fa-check-square' : 'far fa-square'" ></i>
				Eu concordo com as condições de pagamento
			</div>
		</div>

		<button-default
			:color="corPrimaria"
			@click.native="savePayment()"
			text="Confirmar acordo"
			:disable="!checkTerm"></button-default>
	</div>
</template>

<script>
import { mapState, mapMutations, createNamespacedHelpers } from "vuex";
import globalMethods from "@/mixins/globalMethods";
import mixins from "@/mixins/mixins";

import ButtonDefault from "@/components/buttons/ButtonDefault";
import Template from "@/views/admin/Template";
import FormFields from "@/components/FormFields";

const {
	mapActions: mapActionsPassosRetornarDividas,
	mapGetters: mapGettersPassosRetornarDividas,
	mapMutations: mapMutationsPassosRetornarDividas,
} = createNamespacedHelpers("passosRetornarDividas");

export default {
	name: "DetailsMonthlyPayment",

	components: { FormFields, Template, ButtonDefault },

	mixins: [globalMethods, mixins],

	props: {
		parcela: {
			type: Object,
			required: true
		},

		divida: {
			type: Object,
			required: true
		},

		tipoPagamento: {
			type: String,
			required: true
		},

		aVistaOuAPrazo: {
			type: String,
			required: true
		}
	},

	data() {
		return {
			checkTerm: false,
			inputsValues: {},
		};
	},

	computed: {
		...mapState({
			showMessageModal: (estado) => estado.messageModal.show,
			pesCodigo: (estado) => estado.passosRetornarDividas.pessoa.pesCodigo
		}),

		tituloConfirmacaoDePagamento() {
			let tituloConfirmacaoDePagamento = "";

			if (this.parcela.pra_quantidade === 0) {
				tituloConfirmacaoDePagamento = tituloConfirmacaoDePagamento.concat(`R$ ${globalMethods.methods.money2(this.parcela.valor_total_acordo)} à vista`);

			} else if (this.parcela.pra_codigo) {
				tituloConfirmacaoDePagamento = tituloConfirmacaoDePagamento.concat(
				`Entrada de R$ ${globalMethods.methods.money2(this.parcela.pra_valor_entrada)}
				+ ${this.parcela.pra_quantidade}x de R$ ${globalMethods.methods.money2(this.parcela.pra_valor_parcela)}`);

			} else {
				tituloConfirmacaoDePagamento = tituloConfirmacaoDePagamento.concat(`${this.parcela.pra_quantidade}x de R$ ${globalMethods.methods.money2(this.parcela.pra_valor_parcela)}`);
			}

			return tituloConfirmacaoDePagamento;
		},

		textoConfirmarAcordo() {
			return this.parceiroConfig.sessoes.customization.campos.myDebits.detailsMonthlyPayment &&
					this.parceiroConfig.sessoes.customization.campos.myDebits.detailsMonthlyPayment.textConfirmaAcordo ?
					this.parceiroConfig.sessoes.customization.campos.myDebits.detailsMonthlyPayment.textConfirmaAcordo :
					`Ao clicar em 'Confirmar Acordo' o cliente CONCORDA com os valores, datas e forma de pagamento apresentados
								bem como, com as regras de negociação do Credor.O Portal ${this.nomeParceiro} envia diariamente informações de pagamento
								das parcelas ao Credor, para que o mesmo cumpra com as determinações legais junto aos órgãos de proteção ao
								crédito.`;
		},

		tipoPagamentoFormatado() {
			switch (this.tipoPagamento) {
				case 'cartao':
					return 'Cartão de crédito';
				case 'boleto':
					return 'Boleto';
				case 'pix':
					return 'PIX';
			}
		}
	},

	methods: {
		...mapActionsPassosRetornarDividas(["acaoPasso4GravarAcordo"]),

		...mapMutations(['SET_LOADING', 'SET_LOADING_MESSAGE']),

		...mapMutationsPassosRetornarDividas(["SET_MOSTRAR_FORMULARIO_DADOS_CADASTRAIS"]),

		...mapGettersPassosRetornarDividas(["getPesCodigo", "getDadosCadastraisConfirmados", "getMostrarFormularioDadosCadastrais"]),

		savePayment() {
			if (!this.getDadosCadastraisConfirmados()) {
				this.SET_MOSTRAR_FORMULARIO_DADOS_CADASTRAIS(true);
				return;
			}

			if (this.checkTerm) {
				this.action_salvar_etapa({
					pes_codigo: this.pesCodigo,
					esn_fk_ets_codigo: 28,
					emp_codigo: this.parceiroConfig.emp_codigo,
					loj_codigo: this.divida.loja.loj_codigo
				});

				let primeiroVencimento = this.parcela.pra_primeiro_vcto.split('-').reverse().join('/');

				this.SET_LOADING(true);
				this.SET_LOADING_MESSAGE("Aguarde enquanto trabalhamos em sua requisição!");
				this.acaoPasso4GravarAcordo({
					praCodigo: this.parcela.pra_codigo,
					formaDePagamento: this.tipoPagamento,
					primeiroVencimento,
					pagamentoAvistaPrazo: this.aVistaOuAPrazo

				}).then(resposta => {

					if (resposta.retorno) {
						this.SET_LOADING(true);
						this.SET_LOADING_MESSAGE('Aguarde enquanto trabalhamos em sua requisição!');
						setTimeout(() => {
							this.$router.push({name: 'MyAgreements'});
						}, 5000);
					} else {
						this.SET_LOADING(false);
						this.SET_LOADING_MESSAGE('');
						this.CHANGE_MESSAGE_MODAL({
							show: true,
							title: "Erro",
							message: "Volte para a página inicial e recarregue a página, se o erro persistir limpe o cache do navegador",
							styleMessage: "danger"
						});
					}
				});
			}
		}
	}
};
</script>

<style scoped>
h3 {
	margin-top: 20px;
	color: #031b4e;
	font-family: "Roboto Black";
	text-transform: uppercase;
	font-size: 16px;
	text-align: center;
	background: #f5f6fa;
	padding: 10px 0;
}

.iconBoxBack {
	display: flex;
	align-items: center;
	font-size: 16px;
	font-family: "Roboto Black";
	color: var(--primaryColor);
	text-transform: uppercase;
	cursor: pointer;
	margin-top: 15px;
}

.iconBoxBack i {
	margin-right: 10px;
	font-size: 22px;
}

.infos-row {
	margin: 20px 0;
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
	align-items: center;
}

.infos {
	padding: 20px;
}

.infos h6 {
	color: #5b6987;
	font-family: "Roboto";
	font-size: 11px;
	margin-bottom: 3px;
}

.infos h2 {
	color: #031b4e;
	font-family: "Roboto Black";
	font-size: 18px;
}

.img-box {
	width: 110px;
	height: 110px;
	display: flex;
	justify-content: center;
	align-items: center;
	object-fit: cover;
}

.img-box img {
	object-fit: cover;
	width: 110px;
}

.checkTerm {
	color: #031b4e;
	margin: 20px 0 10px 0;
	font-size: 14px;
	font-family: "Roboto Bold";
	display: flex;
	justify-content: flex-start;
	align-items: center;
	cursor: pointer;
}

.checkTerm i {
	font-size: 20px;
	margin: 0 5px 0 0;
}

.px-3 {
	padding: 15px;
}

h6.text-cofirm {
	font-size: 14px;
	line-height: 20px;
	text-align: justify;
}

.row-tabs {
	display: flex;
	justify-content: center;
	align-items: center;
	width: 100%;
	margin: 0 0 0 0;
}

.tab {
	width: 100%;
	text-align: center;
	font-size: 16px;
	text-transform: uppercase;
	padding: 10px 0;
	border-bottom: 3px solid transparent;
	font-family: "Roboto Black";
	color: #9a9a9a;
}

.tab.active {
	border-bottom: 3px solid var(--color);
	font-family: "Roboto Black";
	color: var(--color);
}

.tab:hover {
	cursor: pointer;
}

.hide {
	display: none;
}
</style>
